module.exports = {"api":"https://api.newlife.one","version":"2.0.0-final"}


//////////////////
// WEBPACK FOOTER
// ./env.json
// module id = 108
// module chunks = 2